import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import Input from "./Input"
import classes from "./FlSearchBox.module.scss"

const FlSearchBox = props => {
  const {
    value = "",
    onSearch,
    placeholder = ""
  } = props

  const [t] = useTranslation()

  const [search, setSearch] = useState("")

  const timeout = useRef()

  const handleChange = (e) => {
    clearTimeout(timeout.current)

    const value = e.target.value

    setSearch(value)

    timeout.current =
      setTimeout(() => {
        onSearch(value.trim())
      }, 1200)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  useEffect(() => {
    setSearch(value)
  }, [value])

  return (
    <div className={classes["container"]}>
      <img src="/assets/images/search.svg" alt="" />
      <Input
        value={search}
        className={classes["input"]}
        placeholder={placeholder || t("کالا_ها_را_با_اسم_یا_کد_جست_و_جو_کنید")}
        onChange={handleChange}
      />
    </div>
  )
}

export default FlSearchBox